// extracted by mini-css-extract-plugin
export default {"root":"csv_preview___root___d5686cda","tableWrap":"csv_preview___tableWrap___e421100a","table":"csv_preview___table___e5a8ffcc","current":"csv_preview___current___b06ed36d"};